import React, { Component } from 'react';
import { Logger } from '../infrastructure/Logger';
import { DelayedAction } from '../infrastructure/DelayedAction';
import { ApiDataAccess } from '../infrastructure/ApiDataAccess';
//import { Checkbox } from 'react-bootstrap';

import './DielineImage.css';

export class DielineImage extends Component {

    constructor(props) {
        super(props);

        this.id = this.props.id ? `dieline${this.props.id}` : 'dieline';

        this.request = {
            convertingMethodId: this.props.convertingMethodId,
            length: this.props.length,
            width: this.props.width,
            gusset: this.props.gusset,
            gussetTypeId: this.props.gussetTypeId,
            lengthUomId: this.props.lengthUomId,
            tearNotchId: this.props.tearNotchId,
            tearLineOffset: this.props.tearLineOffset,
            hangholeId: this.props.hangholeId,
            hangholeOffset: this.props.hangholeOffset,
            zipperId: this.props.zipperId,
            zipperOffset: this.props.zipperOffset,
            eyemarkId: this.props.eyemarkId,
            bottomFillId: this.props.bottomFillId,
            valveId: this.props.valveId,
            valveOffset: this.props.valveOffset,
            sideSealWidthId: this.props.sideSealWidthId,
            roundedCornerId: this.props.roundedCornerId,
            doubleCutId: this.props.doubleCutId,
            qrTypeCodeId: this.props.qrCodeTypeId,
            ignoreErrorCodes: this.props.ignoreErrorCodes
        };

        //this.supportedConvertingMethods = Culture.current.dielineSupportedConvertingMethods;

        this.zoom = this.props.zoom && this.props.zoom > 0 ? this.props.zoom : 1;

        this.state = {
            hasRenderingError: false,
            showMenu: false,
            showZoomMenu: false,
            mouseMoving: false
        };

        this.layers = null;
        this.size = null;

        this.dragOrigin = null;
        this.origin = {
            x: 0,
            y: 0
        }

        this.onMouseWheel = this.onMouseWheel.bind(this);
        this.onMouseEvent = this.onMouseEvent.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.showZoomMenu = this.showZoomMenu.bind(this);
        this.onZoomInClick = this.onZoomInClick.bind(this);
        this.onZoomOutClick = this.onZoomOutClick.bind(this);

        this.onActionTriggerClick = this.onActionTriggerClick.bind(this);
        this.onZoomTriggerClick = this.onZoomTriggerClick.bind(this);
        this.onFitClick = this.onFitClick.bind(this);
    }

    isConvertingMethodSupported() {
        return true;
        /*
        if (this.supportedConvertingMethods && this.supportedConvertingMethods.length > 0 && this.request) {
            var idx = this.supportedConvertingMethods.findIndex(e => this.request.convertingMethodId === e);
            return idx >= 0;
        }
        return false;
        */
    }

    componentDidMount() {
        if (this.isConvertingMethodSupported()) {
            Logger.writeDebug("DielineImage: Converting Method is supported.");

            this.setState({
                hasRenderingError: false
            });

            this.refresh(this.zoom)
                .then(() => {
                    this.fit();

                    if (this.props.onInit) {
                        this.props.onInit(this);
                    }
                })
                .catch(() => {
                    if (this.props.onInit) {
                        this.props.onInit(this);
                    }
                });

            var canvas = document.getElementById(this.id + 'canvas');
            var ctx = canvas.getContext("2d");

            canvas.onmousewheel = (evt) => {
                evt.preventDefault();
                this.onMouseWheel(evt, ctx, canvas);
            };

            canvas.onmousedown = (evt) => {
                evt.preventDefault();
                var mouse = {
                    mode: 'down',
                    x: evt.x,
                    y: evt.y
                };
                evt.preventDefault();
                this.onMouseEvent(mouse, ctx, canvas);
            };

            canvas.onmouseup = (evt) => {
                evt.preventDefault();
                var mouse = {
                    mode: 'up',
                    x: evt.x,
                    y: evt.y
                };
                this.onMouseEvent(mouse, ctx, canvas);
            };

            canvas.onmousemove = (evt) => {
                evt.preventDefault();
                var mouse = {
                    mode: 'move',
                    x: evt.x,
                    y: evt.y
                };
                this.onMouseEvent(mouse, ctx, canvas);
            };

            canvas.addEventListener("touchstart", (evt) => {
                evt.preventDefault();
                var touch = evt.touches[0];
                var mouseEvent = new MouseEvent("mousedown", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                canvas.dispatchEvent(mouseEvent);
            }, false);

            canvas.addEventListener("touchend", (evt) => {
                evt.preventDefault();
                var mouseEvent = new MouseEvent("mouseup", {});
                canvas.dispatchEvent(mouseEvent);
            }, false);

            canvas.addEventListener("touchmove", (evt) => {
                evt.preventDefault();
                var touch = evt.touches[0];
                var mouseEvent = new MouseEvent("mousemove", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                canvas.dispatchEvent(mouseEvent);
            }, false);

            canvas.addEventListener('gestureend', (evt) => {
                evt.preventDefault();
                if (evt.scale < 1.0) {
                    if (this.zoom > 0.75) {
                        this.zoom -= 0.1;
                        this.refresh(this.zoom);
                    }
                } else if (evt.scale > 1.0) {
                    if (this.zoom < 5) {
                        this.zoom += 0.1;
                        this.refresh(this.zoom);
                    }
                }
            }, false);
        }
        else {
            Logger.writeDebug("DielineImage: Converting Method is not supported.");

            this.setState({
                hasRenderingError: true
            });

            if (this.props.onInit) {
                this.props.onInit(this);
            }
        }
    }

    refresh(zoom) {
        return new Promise((resolve, reject) => {
            this.zoom = zoom && zoom > 0 ? zoom : 1;
            this.loadAsync(this.request)
                .then(() => {
                    this.draw(this.layers, this.zoom);
                    resolve();
                })
                .catch(ex => {
                    Logger.writeError("DielineImage.refresh", ex);
                    this.layers = null;
                    this.draw(this.layers, this.zoom);
                    reject(ex);
                });
        });
    }

    draw(layers, zoom) {
        Logger.writeDebug("DielineImage.draw");
        var ctxt = this.getGraphicsContext();
        if (ctxt) {
            ctxt.clearCanvas();
            if (layers && layers.length > 0) {
                layers.map((layer, idx) => {
                    if (layer.selected) {
                        layer.draw(ctxt, zoom);
                    }
                });
                this.setState({
                    hasRenderingError: false
                });
            }
            else {
                this.setState({
                    hasRenderingError: true
                });
            }
        }
    }

    getGraphicsContext() {
        var canvas = document.getElementById(this.id + 'canvas');
        if (canvas) {
            var ctx = canvas.getContext("2d");
            return new GraphicsContext(this.id, ctx, canvas);
        }
        return null;
    }

    onMouseEvent(mouse, context, canvas) {

        this.setState({
            mouseMoving: true
        });

        DelayedAction.RunAsync('onMouseEvent', 500)
            .then(() => {
                this.setState({
                    mouseMoving: false
                });
            });

        if (mouse.mode == 'down') {
            this.dragOrigin = {
                x: mouse.x,
                y: mouse.y
            };
            this.showMenu(false);
        }

        if (mouse.mode == 'move' && this.dragOrigin) {

            var zoom = this.zoom > 1 ? this.zoom : 1;
            context.clearRect(-50, -50, canvas.width * zoom + 200, canvas.height * zoom + 200);

            var x = (mouse.x - this.dragOrigin.x) / (this.zoom * 10);
            var y = (mouse.y - this.dragOrigin.y) / (this.zoom * 10);

            this.origin.x = x;
            this.origin.y = y

            context.translate(
                this.origin.x,
                this.origin.y
            );

            this.draw(this.layers, this.zoom);
        }

        if (mouse.mode == 'up' && this.dragOrigin) {
            this.dragOrigin = null;
        }
    }

    onMouseWheel(event, context, canvas) {

        var zoom = this.zoom > 1 ? this.zoom : 1;

        this.resizeCanvas();
        this.showMenu(false);

        var mousex = event.clientX - canvas.offsetLeft;
        var mousey = event.clientY - canvas.offsetTop;
        var wheel = event.wheelDelta / 120;//n or -n
        var zoom = 1 + wheel / 20;

        var newZoom = this.zoom * zoom;
        if (newZoom > 0.75 && newZoom < 5) {

            context.scale(zoom, zoom);

            this.zoom = newZoom;

            context.translate(
                -(mousex / this.zoom + this.origin.x - mousex / (this.zoom * zoom)),
                -(mousey / this.zoom + this.origin.y - mousey / (this.zoom * zoom))
            );

            this.origin = {
                x: (mousex / this.zoom + this.origin.x - mousex / (this.zoom * zoom)),
                y: (mousey / this.zoom + this.origin.y - mousey / (this.zoom * zoom))
            }
        }
        this.draw(this.layers, this.zoom);
    }

    resizeCanvas() {
        var container = document.getElementById(this.id + 'dielineImage');
        var canvas = document.getElementById(this.id + 'canvas');

        if (canvas && container) {
            canvas.width = container.clientWidth;
            canvas.height = container.clientHeight;

            var ctx = canvas.getContext("2d");
            ctx.scale(1, 1);
            ctx.clearRect(-50, -50, canvas.width + 100, canvas.height + 100);
        }
    }

    loadAsync(request) {
        return new Promise((resolve, reject) => {
            this.getMetaDataAsync(request)
                .then(data => {

                    this.setState({
                        errorCodes: data.errorCodes
                    });
                    this.layers = data.layers;
                    this.size = data.size;

                    if (this.props.onLoaded) {
                        this.props.onLoaded(data);
                    }

                    this.resizeCanvas();
                    resolve();
                })
                .catch(ex => {

                    if (this.props.onLoaded) {
                        this.props.onLoaded();
                    }

                    reject(ex);
                });
        });

    }

    getMetaDataAsync(request) {
        this.request = request;

        var settings = {
            loader: false,
            mode: "cors",                                               // no-cors, cors, *same-origin
            cache: 'default',                                           // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include",                                     // include, same-origin, *omit
            redirect: "follow",                                         // manual, *follow, error
            referrer: "no-referrer",                                    // no-referrer, *client
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept-Language": "*"
            }
        };

        this.setState({
            loading: true
        });



        return new Promise((resolve, reject) => {
            var dataAccess = new ApiDataAccess('/api/dielines', settings);
            dataAccess.post('/metadata', request)
                .then(data => {

                    Logger.writeDebug("DielineMetaData:", data);

                    data.layers.sort((a, b) => (a.name > b.name) ? 1 : -1);
                    var layers = [];
                    var idx = 0;
                    data.layers.forEach(l => {
                        var layer = new Layer(idx, l);
                        layers.push(layer);
                        idx++;
                    });

                    var response = {
                        errorCodes: data.errorCodes,
                        layers: layers,
                        size: data.size
                    }
                    this.setState({
                        loading: false
                    });


                    if (request.ignoreErrorCodes && data.errorCodes) {
                        request.ignoreErrorCodes.forEach(item => {
                            var idx = data.errorCodes.findIndex(e => e == item);
                            if (idx > -1) {
                                data.errorCodes.splice(idx, 1);
                            }
                        });
                    }

                    console.log('DATA-ERROR-CODES', data.errorCodes);
                    resolve(response);
                })
                .catch(ex => {
                    Logger.writeError("DielineImage.getMetaDataAsync", ex);
                    this.setState({
                        loading: false
                    });
                    reject(ex);
                });
        });
    }

    setNewDielineRequest(request) {

        if (request.convertingMethodId) {
            this.request.convertingMethodId = request.convertingMethodId;
        }

        if (request.length) {
            this.request.length = request.length;
        }

        if (request.width) {
            this.request.width = request.width;
        }

        if (request.gusset) {
            this.request.gusset = request.gusset;
        }

        if (request.bottomFillId) {
            this.request.bottomFillId = request.bottomFillId;
        }

        if (request.eyemarkId) {
            this.request.eyemarkId = request.eyemarkId;
        }

        if (request.zipperId) {
            this.request.zipperId = request.zipperId;
            if (request.zipperOffset) {
                this.request.zipperOffset = parseFloat(request.zipperOffset);
            }
        }

        if (request.hangHoleId) {
            this.request.hangHoleId = request.hangHoleId;
            if (request.hangHoleOffset) {
                this.request.hangHoleOffset = parseFloat(request.hangHoleOffset);
            }
        }

        if (request.tearNotchId) {
            this.request.tearNotchId = request.tearNotchId;
            if (request.tearNotchOffset) {
                this.request.tearLineOffset = parseFloat(request.tearNotchOffset);
            }
        }

        if (request.valveId) {
            this.request.valveId = request.valveId;
            if (request.valveOffset) {
                this.request.valveOffset = parseFloat(request.valveOffset);
            }
        }

        if (request.qrCodeTypeId) {
            this.request.qrTypeCodeId = request.qrCodeTypeId;
        }

        if (request.sealWidthId) {
            this.request.sideSealWidthId = request.sealWidthId;
        }

        if (request.doubleCutId) {
            this.request.doubleCutId = request.doubleCutId;
        }

        if (request.roundedCornerId) {
            this.request.roundedCornerId = request.roundedCornerId;
        }

        if (request.gussetTypeId) {
            this.request.gussetTypeId = request.gussetTypeId;
        }

        this.request.ignoreErrorCodes = request.ignoreErrorCodes;

        this.refresh(this.zoom);
    }

    setTearNotch(tearNotchId, offset) {
        this.request.tearNotchId = tearNotchId;
        this.request.tearLineOffset = offset ? parseFloat(offset) : this.request.tearLineOffset;
        this.refresh(this.zoom);
    }

    setHangHole(hangHoleId, offset) {
        this.request.hangHoleId = hangHoleId;
        this.request.hangholeOffset = offset ? parseFloat(offset) : this.request.hangholeOffset;
        this.refresh(this.zoom);
    }

    setZipper(zipperId, offset) {
        this.request.zipperId = zipperId;
        this.request.zipperOffset = offset ? parseFloat(offset) : this.request.zipperOffset;
        this.refresh(this.zoom);
    }

    setValve(valveId, offset) {
        this.request.valveId = valveId;
        this.request.valveOffset = offset ? parseFloat(offset) : this.request.valveOffset;
        this.refresh(this.zoom);
    }

    setBottomFill(bottomFillId) {
        this.request.bottomFillId = bottomFillId;
        this.refresh(this.zoom);
    }

    setSideSealWidth(sideSealWidthId) {
        this.request.sideSealWidthId = sideSealWidthId;
        this.refresh(this.zoom);
    }

    setRoundedCorner(roundedCornerId) {
        this.request.roundedCornerId = roundedCornerId;
        this.refresh(this.zoom);
    }

    setGussetType(gussetTypeId) {
        this.request.gussetTypeId = gussetTypeId;
        this.refresh(this.zoom);
    }

    setDoubleCut(doubleCutId) {
        this.request.doubleCutId = doubleCutId;
        this.refresh(this.zoom);
    }

    setQrCodeType(qrCodeTypeId) {
        this.request.qrTypeCodeId = qrCodeTypeId;
        this.refresh(this.zoom);
    }


    showMenu(show) {
        this.setState({
            showMenu: show,
            showZoomMenu: false
        })
    }

    showZoomMenu(show) {
        this.setState({
            showZoomMenu: show,
            showMenu: false,
        })
    }

    onLayerSelected(layer) {
        layer.selected = !layer.selected;
        this.draw(this.layers, this.zoom);
        this.forceUpdate();
    }

    onActionTriggerClick() {
        this.showMenu(!this.state.showMenu);
    }

    onZoomTriggerClick() {
        this.showZoomMenu(!this.state.showZoomMenu);
    }

    onZoomInClick() {
        this.zoom = this.zoom < 5 ? this.zoom += 0.25 : this.zoom;
        this.draw(this.layers, this.zoom);
    }

    onZoomOutClick() {
        this.zoom = this.zoom > 1 ? this.zoom -= 0.25 : this.zoom;
        this.draw(this.layers, this.zoom);
    }

    onFitClick() {
        this.fit();
    }

    fit() {
        var container = document.getElementById(this.id + 'dielineImage');
        var canvas = document.getElementById(this.id + 'canvas');

        if (canvas && container) {
            canvas.width = container.clientWidth;
            canvas.height = container.clientHeight;

            if (canvas) {
                var ctx = canvas.getContext("2d");
                if (ctx) {
                    ctx.scale(1, 1);
                    ctx.clearRect(-50, -50, canvas.width + 100, canvas.height + 100);
                }
            }

            this.zoom = container.clientWidth / this.size.length;
            this.draw(this.layers, this.zoom);
        }
    }

    moveCanvas(zoom, x, y) {
        var canvas = document.getElementById(this.id + 'canvas');
        if (canvas) {
            var ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.scale(1, 1);

                this.origin = {
                    x: x,
                    y: y
                };

                ctx.translate(
                    this.origin.x,
                    this.origin.y
                );

                ctx.scale(zoom, zoom);
            }
        }

    }

    render() {
        return (
            <div>
                <div id={this.id + 'dielineImage'} className='dielineImage'>
                    {this.state.loading &&
                        <div className='loading'>
                            <img className='loader' src={'/images/ajax-loader.gif'} />
                        </div>
                    }

                    {this.state.showMenu
                        ? <div id='actionMenu' className='actionMenu' onMouseLeave={() => { this.showMenu(false); }}>
                            {this.layers && this.layers.map((l, idx) => {
                                return (
                                    <div>
                                        <input type="checkbox" key={'l' + idx} checked={l.selected} onChange={() => { this.onLayerSelected(l) }} />
                                        {l.layer.name}
                                    </div>
                                )
                            })}
                        </div>
                        : <div id='actionTrigger' className={this.state.mouseMoving ? 'trigger actionTrigger fade-in' : 'trigger actionTrigger fade-out'} onClick={this.onActionTriggerClick} onMouseOver={() => { this.showMenu(true); }}><span className='glyphicon glyphicon-align-justify'></span></div>
                    }

                    {this.state.showZoomMenu
                        ? <div id='zoomMenu' className='zoomMenu' onMouseLeave={() => { this.showZoomMenu(false); }}>
                            <div className='btn-round' onClick={this.onZoomInClick}><span className='glyphicon glyphicon-zoom-in'></span></div>
                            <div className='btn-round' onClick={this.onZoomOutClick}><span className='glyphicon glyphicon-zoom-out'></span></div>
                            <div className='btn-round' onClick={this.onFitClick}><span className='glyphicon glyphicon-fullscreen'></span></div>
                        </div>
                        : <div id='zoomTrigger' className={this.state.mouseMoving ? 'trigger zoomTrigger fade-in' : 'trigger zoomTrigger fade-out'} onClick={this.onZoomTriggerClick} onMouseOver={() => { this.showZoomMenu(true); }}><span className='glyphicon glyphicon-search'></span></div>
                    }

                    {/* Dieline cannot be rendered */}
                    {this.state.hasRenderingError &&
                        <div className='error'>Some of the selected features are not compatible with the pouch type!</div>
                    }

                    {/* conflict case */}
                    {!this.state.hasRenderingError && this.state.errorCodes && this.state.errorCodes.length > 0 &&
                        <div className='error'>The Dieline is invalid. The Product cannot be manufactured!</div>
                    }

                    <canvas id={this.id + 'canvas'} />
                </div>
            </div>
        )
    }
}


export class Layer {

    constructor(idx, layer) {
        this.idx = idx;
        this.layer = layer;
        this.selected = true;
    }

    getIndex() {
        return this.idx;
    }

    draw(context, zoom) {
        this.layer.objects.forEach(obj => {
            context.draw(obj, zoom);
        });
    }
}


export class GraphicsContext {

    constructor(id, ctx, canvas) {
        this.id = id;
        this.ctx = ctx;
        this.canvas = canvas;
        this.zoom = 1;
    }

    getCanvasContext() {
        return this.ctx;
    }

    clearCanvas() {
        var zoom = this.zoom > 1 ? this.zoom : 1;
        var c = document.getElementById(this.id + 'canvas');
        var w = c.width * 2;
        var h = c.height * 2;
        this.ctx.scale(1, 1);
        this.ctx.clearRect(-50, -50, w + 100, h + 100);
        this.ctx.scale(zoom, zoom);
    }

    draw(obj, zoom) {
        this.zoom = zoom;
        switch (obj.type) {
            case 'Arc':
                this.drawArc(obj, zoom);
                break;
            case 'Ellipse':
                this.drawEllipse(obj, zoom);
                break;
            case 'Line':
                this.drawLine(obj, zoom);
                break;
            case 'Picture':
                this.drawPicture(obj, zoom);
                break;
            case 'Polygon':
                this.drawPolygon(obj, zoom);
                break;
            case 'Rectangle':
                this.drawRectangle(obj, zoom);
                break;
            case 'Text':
                this.drawText(obj, zoom);
                break;
        }

    }


    drawArc(obj, zoom) {
        var p1 = obj.points[0];
        var p2 = obj.points[1];

        var rx = ((p2.x - p1.x) / 2) * zoom;
        var ry = ((p2.y - p1.y) / 2) * zoom;

        var cx = p1.x * zoom + rx;
        var cy = p1.y * zoom + ry;

        var yOffset = 0;
        var xOffset = 0;

        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;
        this.ctx.lineWidth = obj.pen.width;
        this.ctx.strokeStyle = obj.pen.color;
        if (obj.pen.dashStyle == 'Solid') {
            this.ctx.setLineDash([]);
        }
        else {
            this.ctx.setLineDash([2, 2]);
        }

        if (obj.sweepAngle > 0) {
            var sa = (Math.PI / 180) * obj.startAngle;
            var sw = (Math.PI / 180) * obj.sweepAngle + sa;
            this.ctx.arc(cx + xOffset, cy + yOffset, Math.abs(rx), sa, sw, false);
        }
        else {
            var sa = (Math.PI / 180) * obj.startAngle;
            var sw = (Math.PI / 180) * obj.sweepAngle + sa;
            this.ctx.arc(cx + xOffset, cy + yOffset, Math.abs(rx), sa, sw, true);

        }
        this.ctx.stroke();
    }

    drawEllipse(obj, zoom) {
        var p1 = obj.points[0];
        var p2 = obj.points[1];

        var rx = ((p2.x - p1.x) / 2) * zoom;
        var ry = ((p2.y - p1.y) / 2) * zoom;
        var cx = p1.x * zoom + rx;
        var cy = p1.y * zoom + ry;

        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;
        this.ctx.lineWidth = obj.pen.width;
        this.ctx.strokeStyle = obj.pen.color;
        if (obj.pen.dashStyle == 'Solid') {
            this.ctx.setLineDash([]);
        }
        else {
            this.ctx.setLineDash([2, 2]);
        }

        this.ctx.arc(cx, cy, rx, 0, 2 * Math.PI);
        this.ctx.stroke();
    }

    drawLine(obj, zoom) {
        var p1 = obj.points[0];
        var p2 = obj.points[1];

        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;
        this.ctx.lineWidth = obj.pen.width;
        this.ctx.strokeStyle = obj.pen.color;
        this.ctx.moveTo(p1.x * zoom, p1.y * zoom);
        if (obj.pen.dashStyle == 'Solid') {
            this.ctx.setLineDash([]);
        }
        else {
            this.ctx.setLineDash([2, 2]);
        }

        this.ctx.lineTo(p2.x * zoom, p2.y * zoom);
        this.ctx.stroke();
    }

    drawPicture(obj, zoom) {
    }

    drawPolygon(obj, zoom) {
        var p1 = obj.points[0];

        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;
        this.ctx.lineWidth = obj.pen.width;
        this.ctx.strokeStyle = obj.pen.color;
        if (obj.pen.dashStyle == 'Solid') {
            this.ctx.setLineDash([]);
        }
        else {
            this.ctx.setLineDash([2, 2]);
        }

        this.ctx.moveTo(p1.x * zoom, p1.y * zoom);
        obj.points.forEach(p => {
            this.ctx.lineTo(p.x * zoom, p.y * zoom);
        });

        this.ctx.closePath();

        if (obj.brush.color !== '#FFFFFF') {
            this.ctx.globalAlpha = obj.brush.opacity;
            this.ctx.fillStyle = obj.brush.color;
            this.ctx.fill();
        }
        else {
            this.ctx.globalAlpha = 1;
        }

        this.ctx.stroke();
    }

    drawRectangle(obj, zoom) {
        var p1 = obj.points[0];
        var p2 = obj.points[1];

        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;
        this.ctx.lineWidth = obj.pen.width;
        this.ctx.strokeStyle = obj.pen.color;
        if (obj.pen.dashStyle == 'Solid') {
            this.ctx.setLineDash([]);
        }
        else {
            this.ctx.setLineDash([2, 2]);
        }

        if (obj.brush.color !== '#FFFFFF') {
            this.ctx.globalAlpha = obj.brush.opacity;
            this.ctx.fillStyle = obj.brush.color;
            this.ctx.fillRect(p1.x * zoom, p1.y * zoom, (p2.x - p1.x) * zoom, (p2.y - p1.y) * zoom);
        }
        else {
            this.ctx.globalAlpha = 1;
            this.ctx.rect(p1.x * zoom, p1.y * zoom, (p2.x - p1.x) * zoom, (p2.y - p1.y) * zoom);
        }
        this.ctx.stroke();
    }


    drawText(obj, zoom) {
        var p1 = obj.points[0];

        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;

        this.ctx.save();

        this.ctx.fillStyle = obj.brush.color;
        this.ctx.font = `${obj.fontSize * zoom}px Arial`;

        if (obj.angle > 0) {
            this.ctx.translate((p1.x - obj.fontSize) * zoom, p1.y * zoom);
            this.ctx.rotate((Math.PI / 180) * obj.angle);
            this.ctx.fillText(obj.text, obj.fontSize * zoom * -1, 0);

        }
        else {
            this.ctx.translate(0, 0);
            this.ctx.rotate(0);
            this.ctx.fillText(obj.text, p1.x * zoom, (p1.y - obj.fontSize) * zoom);
        }

        this.ctx.restore();
    }
}